import React, { useEffect, useState } from 'react';
import { subscribeToasts } from '../lib/toast';

const TOAST_MS = 4500;

export function ToastHost() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    return subscribeToasts((toast) => {
      const key = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
      setToasts((prev) => [...prev, { ...toast, key }]);
    });
  }, []);

  useEffect(() => {
    if (!toasts.length) return undefined;
    const timers = toasts.map((t) =>
      setTimeout(() => {
        setToasts((prev) => prev.filter((item) => item.key !== t.key));
      }, TOAST_MS),
    );
    return () => timers.forEach(clearTimeout);
  }, [toasts]);

  if (!toasts.length) return null;

  return (
    <div className="admin-action-toast-stack" role="status" aria-live="polite" aria-atomic="false">
      {toasts.map((t) => (
        <div
          key={t.key}
          className={`admin-action-toast alert shadow-sm mb-0 ${
            t.variant === 'danger'
              ? 'alert-danger'
              : t.variant === 'warning'
                ? 'alert-warning'
                : 'alert-success'
          }`}
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}
